// The job page's writes, each one attempt with one idempotency key (QA-058, QA-744): what the page
// hands back (JobRoute.tsx runs it) named as an attempt and what it sends. The same attempt tried
// again, after a lost answer, sends the same key, so the server does it once; a dialog's next opening,
// a changed input or a success is a new one (attempt-keys.ts). Pure: JobRoute holds the keys.
import type { JobAction } from '@flowology/ui-web/job';
import type { JobPageData } from './job-view-model.ts';

export interface Write {
  /** Which write: one key is held for each at a time. */
  attempt: string;
  /** What it sends, with the dialog's opening: a change is a new attempt. */
  signature: string;
}

/** The page's own action as a write; null for what writes nothing here (going somewhere, opening a dialog). */
export function writeOf(a: JobAction, d: JobPageData): Write | null {
  switch (a.type) {
    case 'complete':
      // the row version it checks is part of what it sends: read again, it's a new attempt
      return { attempt: 'complete', signature: `${a.attempt ?? 0}:${d.review?.rowVersion ?? ''}` };
    case 'sendBack':
      return { attempt: 'sendBack', signature: `${a.attempt ?? 0}:${a.reason}:${a.message.trim()}` };
    case 'fix':
      return { attempt: `fix:${a.fixId}`, signature: a.choice };
    case 'compose':
      return { attempt: `compose:${a.mode}`, signature: a.text.trim() };
    case 'task': {
      const t = d.tasks?.tasks.find((x) => x.id === a.taskId);
      return t ? { attempt: `task:${t.id}`, signature: `${t.rowVersion}:${a.isDone}` } : null;
    }
    case 'share':
      return { attempt: `share:${a.photoId}`, signature: String(a.shared) };
    default:
      return null;
  }
}
